var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicantsTenants(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 10C18.4375 10 17.1709 11.2666 17.1709 12.8289C17.1709 14.3913 18.4375 15.6579 19.9998 15.6579C21.5622 15.6579 22.8288 14.3913 22.8288 12.8289C22.8288 11.2666 21.5622 10 19.9998 10ZM16.6709 12.8289C16.6709 10.9904 18.1613 9.5 19.9998 9.5C21.8384 9.5 23.3288 10.9904 23.3288 12.8289C23.3288 14.6675 21.8384 16.1579 19.9998 16.1579C18.1613 16.1579 16.6709 14.6675 16.6709 12.8289Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7C8.15279 7 6.25 8.90279 6.25 11.25C6.25 13.5972 8.15279 15.5 10.5 15.5C12.8472 15.5 14.75 13.5972 14.75 11.25C14.75 8.90279 12.8472 7 10.5 7ZM5.75 11.25C5.75 8.62665 7.87665 6.5 10.5 6.5C13.1234 6.5 15.25 8.62665 15.25 11.25C15.25 13.8734 13.1234 16 10.5 16C7.87665 16 5.75 13.8734 5.75 11.25Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 18C7.72304 18 5.23911 19.0253 3.54758 20.6392C2.17366 21.9501 1.32494 23.6457 1.25473 25.5H19.7453C19.6324 22.5261 17.5127 19.9513 14.4402 18.7367C13.2457 18.2645 11.9103 18 10.5 18ZM3.20242 20.2775C4.99237 18.5697 7.60217 17.5 10.5 17.5C11.9728 17.5 13.3706 17.7762 14.624 18.2717C17.9272 19.5775 20.25 22.4204 20.25 25.75V26H0.75V25.75C0.75 23.644 1.68162 21.7285 3.20242 20.2775Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3005 23.0001H26.7497V22.7501C26.7497 20.4323 25.1334 18.4624 22.8504 17.5599C21.9835 17.2172 21.0173 17.0264 19.9997 17.0264C18.8598 17.0264 17.7834 17.266 16.8389 17.6908C17.0145 17.7948 17.1869 17.9032 17.3559 18.0158C18.1576 17.7023 19.0532 17.5264 19.9997 17.5264C20.9548 17.5264 21.8586 17.7055 22.6666 18.0249C24.7181 18.8358 26.1315 20.5376 26.2427 22.5001H21.1149C21.1817 22.6645 21.2437 22.8312 21.3005 23.0001Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantsTenants);
export default __webpack_public_path__ + "static/media/applicants-tenants.29e6b2fc.svg";
export { ForwardRef as ReactComponent };